export class CommonUtil {
    public static toLocalDate(content: Date): string {
        const current = new Date(content);
        const offsetMs = current.getTimezoneOffset() * 60 * 1000;
        const dateLocal = new Date(current.getTime() - offsetMs);

        return dateLocal.toISOString().slice(0, 19).replace(/-/g, '/').replace('T', ' ');	
    }

    public static toLocalShortDate(content: Date): string {
        return CommonUtil.toLocalDate(content).slice(0, 10);
    }

	public static isJson(jsonString: string): boolean {
		if (!jsonString || jsonString.length === 0) {
			return true;
		} else {
			try {
				var json = JSON.parse(jsonString);
				return (typeof json === 'object');
			} catch (error) {
				return false;
			}	
		}
	}
}
